import { array, mixed, object, string } from "yup";

import { PreciselyAddressWithUnit } from "@covertree/features";
import { YesNo } from "@covertree/types";
import { SelectOption } from "@covertree/ui";
import { nonEmptyString, phoneNumber, postCode, unit } from "@covertree/utils";

export interface InjuredPerson {
  firstName: string;
  lastName: string;
  address: SelectOption<PreciselyAddressWithUnit>;
  lotUnit?: string;
  phoneNumber: string;
}

export interface InjuredPeopleFormPart {
  wasAnyoneInjured: YesNo;
  injuredPeople: InjuredPerson[];
}

export const injuredPeopleValidation = {
  wasAnyoneInjured: mixed<YesNo>()
    .oneOf(Object.values(YesNo), "Answer to the marked question is required")
    .required(),
  injuredPeople: array()
    .of(
      object({
        firstName: nonEmptyString("First name"),
        lastName: nonEmptyString("Last name"),
        address: object({
          label: string().required(),
          value: object({
            formattedAddress: string().required(),
            streetName: string().required("Street name is missing"),
            city: string().required("City is missing"),
            country: string().required("Country is missing"),
            addressLastLine: string().required(),
            mainAddressLine: string().required(),
            state: string().required("State is missing"),
            addressNumber: string().nullable(),
            postCode: postCode(),
            lotUnit: string().nullable(),
          }),
        })
          .typeError("Address is required")
          .required("Address is required")
          .test("required", "Address is required", ({ value }) => !!value),
        lotUnit: unit(),
        phoneNumber: phoneNumber().required("Phone number is required"),
      })
    )
    .notRequired(),
};
